import { StyleSheet, Text, View } from 'react-native';

import { spacing, unisonColors } from '@/theme';

export interface SectionDateHeaderProps {
  readonly title: string;
  readonly testID?: string;
}

export const SectionDateHeader = ({ title, testID }: SectionDateHeaderProps) => (
  <View style={styles.container} testID={testID}>
    <Text style={styles.title}>{title}</Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    height: spacing[8],
    justifyContent: 'center',
    marginTop: spacing[4],
    marginBottom: spacing[1],
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    color: unisonColors.textNdPrimary,
  },
});
